var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgM55(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_5438_45460",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_5438_45460",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB2klEQVRo3u2ay07CQBSGWcAKd/QtKkiUVmNlb0pCcImReHmDrlh1BdEnwBfQHULCa3BRtuqu8AosjCTjOUmrk3Ir2Mscwkm+DWk6309amJkzsdiu/mqUPtsDjoFLwABMG8P+7ASvEUkYOQTugVdgCrAVTO1rH4CjUVqLRDwB3ABDD8KrGNr3SgQubmU0lC8Bnz6Iu8F7liz5NLBvXQLaAYi7aeFYfsurwCgEeQccS/FLvgBMQpR3wDELfsh/RSDvgGPrG8kzxhRgwqIvdMitKy8BFhOn0CXlVR55YeJVE928BCgycau4Sj4OvAscAN3iywJUmPhVWfbs9wkEGMx9F26rnUzjqcsazz3huat2DmYCyOePNYARoT4vQI9QgJ5bPgl8EwqArkk+gEpI3kHlA5QJBijzAQyCAQw+gEkwgLlVAcg/QuRfYvI/o7T/yAhOJbrz5kJ1QgFqMwFwikpiOg2OOPVftKAZEFjQ9Bcu7oksKa+2d1FPfluFexeaZDe27BApAbcWpXX3R3MCbe4qm26v6wJsr/+7R6CTbXBwIZQIWkxqEE2+Vgjybd+bfL8h9vNOm/UjoDbrxVgOofFtN7qvgTdSjW53jbMaf9RgsMlRg3E2vzvsQbp+AOCEDL+IV4YhAAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgM55);
export default __webpack_public_path__ + "static/media/m55.4c31c6f0b0d6cbf79ca98f6351c45fb7.svg";
export { ForwardRef as ReactComponent };